import { Component, inject, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { AuthService } from '@services/auth.service';
import { SidebarService } from '@services/sidebar.service';
import { SidebarComponent } from '@components/sidebar.component';
import { HeaderComponent } from '@components/ui/header.component';
import { ToastComponent } from '@components/ui/toast.component';
import { FeedbackModalComponent } from '@components/feedback/feedback-modal.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterOutlet, SidebarComponent, HeaderComponent, ToastComponent, FeedbackModalComponent],
  template: `
    <div class="app-container">
      @if (authService.isAuthenticated()) {
        <!-- Header -->
        <app-header></app-header>

        <!-- Sidebar -->
        <app-sidebar></app-sidebar>

        <!-- Content Area -->
        <main class="content-area" [class.sidebar-expanded]="sidebarService.isExpanded()">
          <router-outlet></router-outlet>
        </main>
      } @else {
        <!-- Login Layout (sin sidebar) -->
        <router-outlet></router-outlet>
      }

      <!-- Toast Container Global -->
      <app-toast-container></app-toast-container>

      <!-- Feedback Modal Global -->
      <app-feedback-modal></app-feedback-modal>
    </div>
  `,
  styles: [
    `
      .app-container {
        min-height: 100vh;
      }

      .content-area {
        margin-top: 56px;
        margin-left: 0;
        width: 100%;
        min-height: calc(100vh - 56px);
        transition:
          margin-left 0.25s ease,
          width 0.25s ease;
      }

      .content-area.sidebar-expanded {
        margin-left: 72px;
        width: calc(100% - 72px);
      }
    `,
  ],
})
export class AppComponent implements OnInit {
  private readonly titleService = inject(Title);
  authService = inject(AuthService);
  sidebarService = inject(SidebarService);
  appVersion = environment.appVersion + (environment.production ? '' : '-dev');

  ngOnInit(): void {
    if (!environment.production) {
      this.titleService.setTitle('DEV yuPanel');
    }
  }
}
